"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const AllBrandsQuery = (0, graphql_tag_1.default)(`
query($letter: String! = "a", $page: Int = 1, $pageSize: Int = 30) {
  brandList(brandListRequest: { letter: $letter, page: $page, pageSize: $pageSize }) {
    brands {
      slug
      letter
      brand
    }
    pageSize
    pages
    records
  }
}`);
exports.default = AllBrandsQuery;
